import React from 'react';
import { StyledIndustriesCarouselMenu } from './StyledIndustriesCarouselMenu';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useHistory } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  setLoader,
} from "../../redux/loader/loader.actions";

SwiperCore.use([Navigation]);


const IndustriesCarouselMenu = ({ children, colorCTA, black, slider, noMarginTop, noPaddingBottom }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }

  const fullSlider = [
    {
      img: require("../../assets/carousel-industries/3dcommerce.jpg"),
      title: "3D e-commerce",
      route: "/3d-e-commerce"
    },
    {
      img: require("../../assets/carousel-industries/virtual-showroom.jpg"),
      title: "Virtual Showroom",
      route: "/virtual-showroom"
    },
    {
      img: require("../../assets/carousel-industries/shelfzone.png"),
      title: "Shelfzone",
      route: "/shelfzone"
    },
   
  ]

  // let slicedSlider = []
  // for(var i = 0; i < slider.length; i++){
  //   slicedSlider.push(fullSlider[slider[i]])
  // } 


  return (
    <React.Fragment>
      {
       
          <StyledIndustriesCarouselMenu noMarginTop={noMarginTop} noPaddingBottom={noPaddingBottom}>
            <div className="carousel--head">
              <h5 className="big--title" style={{color: black}}>But wait, there’s more...</h5>
              <div className="cta--primary cursor-cta" onClick={() => handleCLick('/products/index')}>
                  <p className="preset-10 cursor-cta" style={{color: colorCTA}} >View all</p>
                  <svg width="14" className="next  cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={colorCTA} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path className="cursor-cta" d="M13 6H1" stroke={colorCTA} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
            </div>
              
            <Swiper 
              slidesPerView={ "auto"}
              spaceBetween={0}
              className="carousel-industries--slider"
              navigation
              
              >
                {
                  fullSlider.map((item, index) => {
                    return  <SwiperSlide key={index} onClick={() => handleCLick(item.route)}>
                              <div className="img-wrap">
                                <img src={item.img} />
                              </div>
                              <p className="preset-9" style={{color: black}}>{item.title}</p>
                            </SwiperSlide>
                  } )
                }
              </Swiper>
            {children}
          </StyledIndustriesCarouselMenu>
          
      }
    </React.Fragment>
  );
};

export default IndustriesCarouselMenu;
